module.exports = __webpack_public_path__ + "static/media/attack.2988684e.png";